import {
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { EoiSectionsComponent } from '../project-development/tendering/project-expression-of-interest/eoi-sections/eoi-sections.component';
import { PqqSectionsComponent } from '../project-development/tendering/pqq/pqq-developer/pqq-sections/pqq-sections.component';
import { ApplicantPqqSectionsComponent } from '../project-requests/requested-tendering/requested-pqq/applicant-pqq-sections/applicant-pqq-sections.component';
import { IttWrapperComponent } from '../project-development/tendering/inivitation-to-tender/itt-sender-side/itt-creation/itt-wrapper/itt-wrapper.component';
import { TenderingService } from '@/app/services/tendering-services/tendering.service';
import { RfqWrapperComponent } from '../project-development/tendering/rfq/rfq-sender-side/rfq-creation/rfq-wrapper/rfq-wrapper.component';
import { RfqSectionDialogsComponent } from '../project-requests/requested-tendering/requested-rfq/rfq-section-dialogs/rfq-section-dialogs.component';
@Component({
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    EoiSectionsComponent,
    PqqSectionsComponent,
    ApplicantPqqSectionsComponent,
    IttWrapperComponent,
    RfqWrapperComponent,
    RfqSectionDialogsComponent,
  ],
  selector: 'app-wrapper',
  templateUrl: './wrapper.component.html',
  styleUrls: ['./wrapper.component.css'],
})
export class WrapperComponent implements AfterViewInit {
  @Output() handleDialog: EventEmitter<any> = new EventEmitter<any>();
  @Input() currentDialog: string;
  @Input() isEdit: boolean;
  @Input() currentEOISavedData: any = [];
  @Input() pqqInputData: any;
  @Input() rfpResponseData: any;
  @ViewChild('dialogTemplate') dialogTemplate!: TemplateRef<any>;

  constructor(
    public dialog: MatDialog,
    private tenderingService: TenderingService
  ) {}

  ngAfterViewInit(): void {
    this.openDialog();
  }

  openDialog(): void {
    this.dialog.open(this.dialogTemplate, {
      width: '89vw',
      height: 'fit-content',
      maxHeight: '90vh',
      disableClose: true,
      autoFocus: false,
    });
  }

  closeDialog(): void {
    this.dialog.closeAll();
    this.handleDialog.emit();
    this.isEdit = false;

    // TODO: we should not import services here as this is global component
    // IMP: when we close the model, we need to set ittId to null
    if (this.currentDialog == 'itt-wrapper') {
      this.tenderingService.setIttId(null);
    }
  }

  handleCloseModal(closeModalValue: boolean) {
    if (closeModalValue) {
      this.closeDialog();
    }
  }
}
